import { Navigate } from "react-router";

/**
 * Auth callback (route `/auth/callback`). Per `docs/plan/08-auth-worker.md`,
 * a Cloudflare edge worker owns this path in production: it exchanges the
 * one-time `?code=` for the session JWT itself and sets an httpOnly cookie,
 * then redirects here — so this React route never sees `?code=` in
 * production, and no exchange ever happens in dev (no worker locally)
 * either. A failed exchange's `?auth_error=` is surfaced globally by
 * `RootLayout`, which mounts regardless of the matched route, so this stub's
 * only remaining job is to not hang on "Signing you in…" forever — bounce
 * home (review MINOR finding 6).
 */
export function AuthCallback() {
  return <Navigate to="/" replace />;
}
